const DEFAULT_APP_TITLE = 'ConnectGroove';

const HOST_APP_TITLES: Record<string, string> = {
  'leads.trevi.ca': 'Trévi CRM+',
};

export const DEFAULT_FAVICON_HREF = '/logo-connect-groove.svg';

export function getBrowserAppTitle(
  hostname = window.location.hostname,
  devStackId = import.meta.env.VITE_DEV_STACK_ID
) {
  const appTitle = HOST_APP_TITLES[hostname] || DEFAULT_APP_TITLE;
  const normalizedStackId = devStackId?.trim();

  return normalizedStackId ? `${appTitle} · ${normalizedStackId}` : appTitle;
}
